import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebProcessKickoff,
  EcommerceWebProcessStack,
  EcommerceWebProcessUIUX,
  EcommerceWebProcessFrontend,
  EcommerceWebProcessQuality,
  EcommerceWebProcessLaunch,
} from "../../../app-constants";
import BgImg from "../../images/services-usa/ecommerce_web/ecommerce_back.webp";
import { Link } from "gatsby";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our eCommerce <span>Web Development</span> Process
            </h2>
            <p>
              Our e-commerce website development services leverage lean, agile
              methodology for a collaborative journey and rapid turnarounds.
              Experience the eCommerce success gained by numerous business
              partners through our optimized, results-driven development
              process.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>Project Kick-Off</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessKickoff}
                </div>
              </div>
              <p>
                Assess project scope and set clear objectives with expert
                consultation.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>Technology Stack Selection</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessStack}</div>
              </div>
              <p>
                Choose the optimal tech stack tailored to your project’s
                specific needs.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>UI/UX Design</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessUIUX}</div>
              </div>
              <p>
                Craft an engaging, user-friendly interface with our design
                specialists.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>Backend & Frontend Development</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessFrontend}
                </div>
              </div>
              <p>
                Implement functionality and robust backend features with our
                skilled developers.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>Quality Assurance</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessQuality}
                </div>
              </div>
              <p>
                Conduct thorough testing and debugging to ensure a flawless
                product.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>Launch & Ongoing Support</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessLaunch}</div>
              </div>
              <p>
                Deploy your e-commerce site and provide continuous maintenance
                and updates.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Learn More on eCommerce Development
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
